import { create } from 'zustand';
import { Option } from '../data/Option';

type OptionDrawerStore = {
    isOpen: boolean,
    isEdit: boolean,
    data: Option | undefined,
    openNew: () => void,
    openEdit: (data: Option) => void,
    close: () => void,
}

export const useOptionDrawerStore = create<OptionDrawerStore>((set) => ({
    isOpen: false,
    isEdit: false,
    data: undefined,
    openNew: () => set(() => ({ isOpen: true, isEdit: false, data: undefined })),
    openEdit: (option: Option) => set(() => ({ isOpen: true, isEdit: true, data: option })),
    close: () => set(() => ({ isOpen: false, data: undefined })),
}));